import BlockPadding from '@/components/block-padding';
import RichText from '@/components/rich-text';

export default function Copy({ data }: { data: any }) {
  return (
    <BlockPadding maxWidth="small">
      <RichText data={data?.copy} />
    </BlockPadding>
  );
}
